import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import styles from "./mayatool.module.scss";

export default function MayaTool({ showGulf }) {
  const [selectedDay, setSelectedDay] = useState();
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedYear, setSelectedYear] = useState();
  const [kin, setKin] = useState();

  const years = [
    62, 167, 12, 117, 222, 67, 172, 17, 122, 227, 72, 177, 22, 127, 232, 77,
    182, 27, 132, 237, 82, 187, 32, 137, 242, 87, 192, 37, 142, 247, 92, 197,
    42, 147, 252, 97, 202, 47, 152, 257, 102, 207, 52, 157, 2, 107, 212, 57,
    162, 7, 112, 217,
  ];

  const months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 13, 44, 74];

  const days = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
    { label: "11", value: 11 },
    { label: "12", value: 12 },
    { label: "13", value: 13 },
    { label: "14", value: 14 },
    { label: "15", value: 15 },
    { label: "16", value: 16 },
    { label: "17", value: 17 },
    { label: "18", value: 18 },
    { label: "19", value: 19 },
    { label: "20", value: 20 },
    { label: "21", value: 21 },
    { label: "22", value: 22 },
    { label: "23", value: 23 },
    { label: "24", value: 24 },
    { label: "25", value: 25 },
    { label: "26", value: 26 },
    { label: "27", value: 27 },
    { label: "28", value: 28 },
    { label: "29", value: 29 },
    { label: "30", value: 30 },
    { label: "31", value: 31 },
  ];

  const monthOptions = [
    { label: "Januari", value: 0 },
    { label: "Februari", value: 1 },
    { label: "Maart", value: 2 },
    { label: "April", value: 3 },
    { label: "Mei", value: 4 },
    { label: "Juni", value: 5 },
    { label: "Juli", value: 6 },
    { label: "Augustus", value: 7 },
    { label: "September", value: 8 },
    { label: "Oktober", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 },
  ];

  const symbolen = [
    "Rode Draak",
    "Witte Wind",
    "Blauwe Nacht",
    "Gele Zaad",
    "Rode Slang",
    "Witte Wereldoverbrugger",
    "Blauwe Hand",
    "Gele Ster",
    "Rode Maan",
    "Witte Hond",
    "Blauwe Aap",
    "Gele Mens",
    "Rode Hemelwandelaar",
    "Witte Tovenaar",
    "Blauwe Adelaar",
    "Gele Krijger",
    "Rode Aarde",
    "Witte Spiegel",
    "Blauwe Storm",
    "Gele Zon",
  ];

  const generateYearOptions = () => {
    let curDate = new Date();
    let curYear = curDate.getFullYear();
    let curOptions = [];
    for (let i = curYear + 10; i >= curYear - 100; i--) {
      curOptions.push({ label: i, value: i });
    }
    return curOptions;
  };

  const yearOptions = generateYearOptions();

  const updateKin = () => {
    const birthDate = new Date(
      selectedYear.value,
      selectedMonth.value,
      selectedDay.value
    );
    const originalKin =
      years[(birthDate.getFullYear() + 14) % 52] +
      months[birthDate.getMonth()] +
      birthDate.getDate();
    originalKin > 260 ? setKin(originalKin - 260) : setKin(originalKin);
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected || state.isFocused ? "#ECF2FE" : "",
      color: state.isSelected ? "black" : "",
      fontFamily: "montserrat",
      fontSize: "13.33px",
      cursor: "pointer",
    }),
    control: (provided) => {
      const fontFamily = "montserrat";
      const fontSize = "14px";
      const border = "none";
      const borderRadius = "0px";
      const borderBottom = "1px solid #333333";
      const backgroundColor = "none";
      return {
        ...provided,
        fontFamily,
        fontSize,
        border,
        borderRadius,
        borderBottom,
        backgroundColor,
      };
    },
    container: (provided) => ({
      ...provided,
      flexGrow: "1",
      width: "auto",
      display: "inline-block",
      marginRight: "10px",
    }),
    input: (provided) => ({
      ...provided,
      color: "#333333",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#333333",
    }),
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        minHeight: "100vh",
        alignItems: "stretch",
        background:
          "linear-gradient(90deg, rgba(255, 255, 255, 0.91), rgba(255, 255, 255, 0.91)), url(/Background.jpg)",
        backgroundSize: "cover",
      }}
    >
      {/* <div className={styles.sidebar}></div> */}
      <div
        style={{
          flexGrow: 1,
          // backgroundImage:
          //   'url("https://images.pexels.com/photos/5484585/pexels-photo-5484585.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260")',
          // background:
          //   'linear-gradient(90deg, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.7)), url("https://images.pexels.com/photos/5484585/pexels-photo-5484585.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260")',
          // backgroundSize: "cover",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingBottom: "40px",
        }}
      >
        <div
          style={{
            width: "350px",
            height: "400px",
            backgroundImage: `url(/Logo_studioprana.png)`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            alignContent: "center",
          }}
        ></div>
        <p
          style={{
            fontSize: "40px",
            fontFamily: "Nunito Sans",
            fontWeight: "100",
            color: "#de9a5f",
            height: "40px",
            marginTop: "-20px",
          }}
        >
          Tzolkin calculator
        </p>
        <div style={{ marginBottom: "20px" }}>
          <Select
            onChange={(e) => setSelectedDay(e)}
            value={selectedDay}
            options={days}
            styles={customStyles}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
          <Select
            onChange={(e) => setSelectedMonth(e)}
            value={selectedMonth}
            options={monthOptions}
            styles={customStyles}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
          <Select
            onChange={(e) => setSelectedYear(e)}
            value={selectedYear}
            options={yearOptions}
            styles={customStyles}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </div>

        <div className={styles.btnGrey} onClick={() => updateKin()}>
          Bereken mijn zegel en toon
        </div>
        <div style={{ height: "60px" }}></div>

        {kin ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gridTemplateRows: "1fr",
              gridColumnGap: "20px",
              margin: "5px",
            }}
          >
            <div className={styles.resultHolder}>
              <div className={styles.resultHeading}>Kin</div>
              <div>{kin}</div>
            </div>

            <div className={styles.resultHolder}>
              <div className={styles.resultHeading}>Zegel</div>
              <div>{symbolen[(kin - 1) % 20]}</div>
            </div>

            <div className={styles.resultHolder}>
              <div className={styles.resultHeading}>
                Toon: {((kin - 1) % 13) + 1}{" "}
              </div>
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundImage: `url(/tonen/Tonen-${(
                    ((kin - 1) % 13) +
                    1
                  ).toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                    useGrouping: false,
                  })}.png)`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {/* <div>
        <div
          style={{
            // backgroundImage:
            //   'url("https://static.wixstatic.com/media/2e1700_ade890de2296491781f82eaf8a9f70a7~mv2.jpg/v1/fill/w_980,h_748,al_c,q_85,usm_0.66_1.00_0.01/2e1700_ade890de2296491781f82eaf8a9f70a7~mv2.webp")',
            backgroundImage:
              'url("https://images.pexels.com/photos/5484585/pexels-photo-5484585.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260")',
            backgroundSize: "cover",
            backgroundPosition: "40%",
            height: "100%",
            width: "600px",
          }}
        ></div>
      </div> */}
    </div>
  );
}
